export const MerchantSelectSuccessViewStyles = {
  container: 'w-full text-center mt-10 mb-10 md:max-w-screen-md',
  headerText: 'text-green',
  checkMarkIcon: 'mr-2 text-green w-10 h-10',
  buttonWrapper: 'flex max-w-full justify-center mt-10',
  backButtonContainer: 'flex items-center mr-auto cursor-pointer',
  buttonContainer: 'text-xl sm:text-2xl',
}
